import layout from '@/layout'
const meta = { auth: true }

export default {
  path: '/material',
  component: layout,
  children: ((pre) => [
    {
      path: 'materialCategory',
      name: `${pre}materialCategory`,
      meta: {
        ...meta,
        cache: true,
        title: '物料分类维护',
        head: true,
        funcID: 'B0201',
        PID: 'B00'
      },
      component: () => import('@/views/backstage/material/materialCategory')
    },
    {
      path: 'materialMetadata',
      name: `${pre}materialMetadata`,
      meta: {
        ...meta,
        cache: true,
        title: '物料属性字典',
        head: true,
        funcID: 'B0202',
        PID: 'B00'
      },
      component: () => import('@/views/backstage/material/materialMetadata')
    },
    {
      path: 'materialInputTemplate',
      name: `${pre}materialInputTemplate`,
      meta: {
        ...meta,
        cache: true,
        title: '物料信息模板维护',
        head: true,
        funcID: 'B0203',
        PID: 'B00'
      },
      component: () =>
        import('@/views/backstage/material/materialInputTemplate')
    },
    {
      path: 'materialInfoSet',
      name: `${pre}materialInfoSet`,
      meta: {
        ...meta,
        cache: true,
        title: '物料信息维护',
        head: true,
        funcID: 'B0204',
        PID: 'B00'
      },
      component: () => import('@/views/backstage/material/materialInfoSet')
    },
    {
      path: 'materialInfoSet/:pageType/:materialCode?',
      name: `${pre}materialInfoSet-detail`,
      meta: {
        ...meta,
        cache: false,
        title: '物料信息维护',
        head: false,
        funcID: 'B0204',
        PID: 'B00'
      },
      component: () =>
        import('@/views/backstage/material/materialInfoSet/detail')
    }
  ])('material-')
}
